
<div style="margin-top: 20px;margin-left: 20px;">
    <a href="https://www.McDermott.com"> <img
                            src="../../../assets/img/mcdermott_logo.png" alt="McDermott.com Webpage"
                            style="width: 300px; height: 50px; border: 0"></a>

    <h2>An error occured! Something went wrong.</h2>

    <span>You are not authorized to access iDocs<sup style="font-size: x-small; vertical-align: super; line-height: 0;">XD</sup>
     Portal. Your account might be disabled.     
    </span>
    <br>
    <br>
    <span>Please contact iDocs Support if you need to access iDocs<sup style="font-size: x-small; vertical-align: super; line-height: 0;">XD</sup>
         Portal:<br>
        <br>
        <a href="mailto:iDocs_Support_Global@mcdermott.com">iDocs_Support_Global&#64;mcdermott.com</a>
    </span>


</div>

